"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _ = require("..");

/**
 * @todo: Is this a function or const please confirm ?
 * @param {*} data 
 */
function _default(data) {
  (0, _.apiCallLogger)(data);
}